var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { StyledInputText } from './input-text';
import Loader from './loader';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: stretch;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n"], ["\n  align-items: stretch;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n"])));
var LoaderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-self: stretch;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n"], ["\n  align-self: stretch;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n"])));
var ResultsList = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  margin-top: 0.25rem;\n  position: absolute;\n  top: 100%;\n  z-index: 1;\n\n  &.empty,\n  &.blurred {\n    display: none;\n  }\n"], ["\n  background-color: ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  margin-top: 0.25rem;\n  position: absolute;\n  top: 100%;\n  z-index: 1;\n\n  &.empty,\n  &.blurred {\n    display: none;\n  }\n"])), function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level3 : p.theme.level0;
}, function (p) {
  return p.theme.borderWidth;
}, function (p) {
  return p.theme.level4;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return p.theme.textSecondary;
});
var Result = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-left: 3px solid ", ";\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n"], ["\n  border-left: 3px solid ", ";\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n"])), function (p) {
  return p.selected ? p.theme.primary : 'transparent';
}, function (p) {
  return p.theme.level2;
});

var InputAutocomplete = function InputAutocomplete(_a) {
  var _b = _a.defaultValue,
      defaultValue = _b === void 0 ? '' : _b,
      emptyResult = _a.emptyResult,
      fetcher = _a.fetcher,
      inputRef = _a.inputRef,
      name = _a.name,
      onSelect = _a.onSelect,
      props = __rest(_a, ["defaultValue", "emptyResult", "fetcher", "inputRef", "name", "onSelect"]);

  var _c = useState(false),
      blurred = _c[0],
      setBlurred = _c[1];

  var _d = useState(false),
      loading = _d[0],
      setLoading = _d[1];

  var _e = useState(defaultValue),
      search = _e[0],
      setSearch = _e[1];

  var _f = useState([]),
      results = _f[0],
      setResults = _f[1];

  var _g = useState(null),
      selected = _g[0],
      setSelected = _g[1];

  var onChange = function onChange(e) {
    var val = e.target.value;
    setSearch(val);
  };

  var selectItem = function selectItem(result) {
    console.log(result);
    setSelected(result.id);
    setSearch(result.name);
    onSelect && onSelect(result);
  };

  useEffect(function () {
    var fetchData = function fetchData() {
      return __awaiter(void 0, void 0, void 0, function () {
        var matches;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setLoading(true);
              return [4
              /*yield*/
              , fetcher(search)];

            case 1:
              matches = _a.sent();
              setResults(matches);
              setLoading(false);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    fetchData();
  }, [fetcher, search]);
  return React.createElement(Wrapper, null, React.createElement(StyledInputText, Object.assign({
    className: "input-autocomplete",
    name: name,
    onChange: onChange,
    onBlur: function onBlur() {
      return setBlurred(true);
    },
    onFocus: function onFocus() {
      return setBlurred(false);
    },
    ref: inputRef,
    value: search,
    type: "text"
  }, props)), React.createElement(ResultsList, {
    className: "input-autocomplete-results " + (results.length === 0 && !emptyResult && !loading && 'empty') + " " + (blurred && 'blurred')
  }, loading ? React.createElement(LoaderWrapper, null, React.createElement(Loader, {
    size: 1
  })) : React.createElement(React.Fragment, null, results.length === 0 && emptyResult, results.map(function (r, i) {
    return React.createElement(Result, {
      key: name + "-result-" + i,
      selected: r.id === selected,
      onMouseDown: function onMouseDown() {
        return selectItem(r);
      }
    }, r.render());
  }))));
};

export default InputAutocomplete;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;